var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.titleOne))]),_c('TableOne',{attrs:{"readOnly":_vm.readOnly,"horasExtraordinarias":_vm.horasExtraordinarias}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }